// extracted by mini-css-extract-plugin
export default {"SearchInput":"SearchInput_SearchInput__56hKj"};